import { TitleCasePipe } from "@angular/common";
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { FormBuilder, FormArray, Validators, FormGroup } from "@angular/forms";
import { MenuItem, MessageService } from "primeng/api";
import { AppMainService } from "src/app/app-main.service";
import { ShippingService } from "src/app/configurations/integration/shipping/shipping.service";
import { PackBoxService } from "src/app/configurations/inventory/setup/pack-box/pack-box.service";
import { Severity } from "src/app/inventory/constants/constants";
import { SOChannel, SoStageId } from "src/app/inventory/sales-order/constants/constants";
import { SalesOrderService } from "src/app/inventory/sales-order/sales-order.service";
import { Status } from "src/app/models/statusEnums";
import { ShippingmethodService } from "../../../../configurations/inventory/setup/shippingmethod/shippingmethod.service";
import { ImportserialService } from "../../services/importserial.service";
import { Subject, takeUntil } from "rxjs";

@Component({
    selector: "app-ups-shipment",
    templateUrl: "./ups-shipment.component.html",
    styleUrls: ["./ups-shipment.component.scss"],
})
export class UpsShipmentComponent implements OnInit {
    @Input() detailsObj;
    @Input() channel;
    @Input() vendorUpsInfo;
    @Input() fedexAccountInfo;
    @Input() allShippingMethods;
    @Input() allUpsAccounts;
    @Input() displayAddPackage;
    @Input() selectedCarrier;
    @Output() onSuccessfullUpsShipment = new EventEmitter();
    @Output() onStepChange = new EventEmitter();
    @Output() onClose = new EventEmitter();

    @ViewChild("stepper") stepper: ElementRef;
    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    menus: MenuItem[];
    activeIndex = 0;
    packageType: any[] = [];
    selectedOption: string[] = [];
    packageGroup = [{}];
    selectedService;
    shippingAddress;
    form:FormGroup = this.fb.group({ packages: this.fb.array([]) });
    shipmentRates: any[] = [];
    shipment;
    isSinglePackage = false;
    order;
    allPackBoxes: any[] = [];
    defaultPackage;
    paymentMethod: any[] = [];
    defaultMethod;
    ratesText;
    createLabelSubmitted = false;
    minimumDate = new Date();
    shippingAddressContact;
    codAmount = 0;
    isVisibleShipCostField = false;
    shippingCost = 0;
    isVisibleCodField = false;
    isFreeShipping = false;
    country: any[] = [];
    selectedCountry;
    selectedState;
    selectedCity;
    states;
    city;
    paymentDetails;
    thirdPartyBilling = false;
    upsServices: any[] = [];

    massOptions = [
        { id: 1, name: "Pound", code: "POUND" },
        { id: 2, name: "Kilogram", code: "KILOGRAM" },
        { id: 3, name: "Ounce", code: "OUNCE" },
        { id: 4, name: "Stone", code: "STONE" },
    ];
    packageAmount = [
        { id: 1, name: "1" },
        { id: 2, name: "2" },
        { id: 3, name: "3" },
        { id: 4, name: "4" },
    ];
    batteryPackageTypes = [
        {
            id: 1,
            name: "Alone in Box",
            value: "01",
        },
        {
            id: 2,
            name: "Contained or installed in equipment",
            value: "02",
        },
        {
            id: 3,
            name: "Packaged separately with other equipment",
            value: "03",
        },
    ];
    typesOfBattery = [
        {
            id: 1,
            name: "Lithium Ion",
            value: "01",
        },
        {
            id: 2,
            name: "Lithium Metal",
            value: "02",
        },
    ];
    signatureOptions = [
        {
            id: 1,
            name: "Adult Signature Required",
            value: "3",
        },
        {
            id: 2,
            name: "Signature Required",
            value: "2",
        },
    ];
    soChannel = SOChannel;
    codFundsCodeEightFor: string[] = ["cod cashiers check", "cod money order"]; // fund code 8
    // fraction digits
    fractionDigits: number = 0;

    constructor(
        private fb: FormBuilder,
        private salesOrderService: SalesOrderService,
        private packBoxService: PackBoxService,
        private messageService: MessageService,
        private titlecasePipe: TitleCasePipe,
        private appMainService: AppMainService,
        private shippingService: ShippingService,
        private shippingMethodService: ShippingmethodService,
        private importService: ImportserialService
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.detailsObj && changes.detailsObj.currentValue) {
            this.detailsObj = changes.detailsObj.currentValue;
            this.shippingAddress = this.detailsObj?.account?.accountAddresses?.filter((d) => d.addressId == this.detailsObj.shippingAddressId)[0];
            this.paymentMethod = [];
            if (this.detailsObj?.account?.accountPaymentMethods) {
                this.detailsObj?.account?.accountPaymentMethods.forEach((e) => {
                    this.paymentMethod.push(e.paymentMethod);
                });
            }
            this.defaultMethod = this.paymentMethod?.find((m) => m.id == this.detailsObj?.paymentMethodId);
            this.shippingAddressContact = this.detailsObj?.shipContact;
        }
        if (changes.displayAddPackage && changes.displayAddPackage.currentValue) {
            this.displayAddPackage = changes.displayAddPackage.currentValue;
            if (this.displayAddPackage) {
                this.initForm();
                this.addPackage();
            }
        }
        this.activeIndex = 0;
        this.createLabelSubmitted = false;
        this.selectedService = null;
    }

    ngOnInit(): void {
        this.getFractionDigits();
        this.menus = [{}, {}, {}, {}];
        this.getAllPackBoxList();
        this.getAllCountry();
        this.getUpsServices();
    }
    getFractionDigits() {
        this.importService
            .getDecimalValue()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (value) => {
                    if(value){
                        this.fractionDigits = value;
                    }
                },
                error: (error) => {},
            });
    }

    getUpsServices() {
        this.upsServices = [];
        this.appMainService.isShowSpinner("loadUpsService");
        this.shippingMethodService.getUpsServiceList(1).subscribe({
            next: (res) => {
                this.upsServices = res;
                this.appMainService.isHideSpinner("loadUpsService");
            },
            error: (error) => {
                this.appMainService.isHideSpinner("loadUpsService");
                this.messageService.add({
                    severity: Severity.Error,
                    summary: this.titlecasePipe.transform(Severity.Error),
                    detail: "Error occurred ...",
                });
            },
        });
    }

    getAllPackBoxList() {
        this.packageType = [];
        this.packBoxService.getPackBoxListWithHierarchy().subscribe(
            (res) => {
                this.allPackBoxes = res;
                const allPackages: any[] = [];
                let defaultChild;
                if (this.allPackBoxes && this.allPackBoxes.length) {
                    this.allPackBoxes.forEach((box) => {
                        if (box.statusId == Status.Active) {
                            const child: any[] = [];
                            if (box.childPackBoxes && box.childPackBoxes.length) {
                                box.childPackBoxes.forEach((ch) => {
                                    if (ch.statusId == Status.Active) {
                                        const childData = {
                                            label: ch.name,
                                            value: ch.id,
                                            data: ch,
                                        };
                                        child.push(childData);
                                        if (ch.isDefault) {
                                            defaultChild = childData;
                                        }
                                    }
                                });
                            }
                            const parentData = {
                                label: box.name,
                                value: box.id,
                                children: child,
                            };
                            allPackages.push(parentData);
                            if (box.isDefault && defaultChild && defaultChild.data.parentId == box.id) {
                                this.defaultPackage = defaultChild;
                            }
                        }
                    });
                }
                this.packageType = allPackages;
            },
            (error) => {
                this.messageService.add({
                    severity: Severity.Error,
                    summary: this.titlecasePipe.transform(Severity.Error),
                    detail: "Error occurred...",
                });
            },
        );
    }

    initForm() {
        this.form = this.fb.group({
            packages: this.fb.array([]),
        });
    }

    editPackage() {}

    backStep(step) {
        var arr = document.getElementsByClassName("p-steps-item");
        for (let i in this.menus) {
            if (i >= step) {
                arr[i].classList.remove("activeItem");
            }
        }
        this.activeIndex = this.activeIndex - 1;
        if (step == 2) {
            this.selectedService = null;
        } else if (step == 3) {
            this.createLabelSubmitted = false;
        }
        if (this.activeIndex == 0) {
            this.onStepChange.emit(true);
        }
    }

    nextStep(step) {
        var arr = document.getElementsByClassName("p-steps-item");
        for (let i in this.menus) {
            if (i < step + 1) {
                arr[i].classList.add("activeItem");
            }
        }
        if (step == 1) {
            this.checkBillingAccount();
        } else if (step == 2) {
            this.shippingCost = this.selectedService?.monetaryValue;
            this.calculateCODAmount();
        }
        this.activeIndex = this.activeIndex + 1;
        if (this.activeIndex > 0) {
            this.onStepChange.emit(false);
        }
    }

    calculateCODAmount() {
        /**
         * Total COD amount is addition of ordertotal, service cost & cod charge
         */
        this.codAmount = 0;
        const formValue = this.form.value.packages[0];
        if (formValue.cod && formValue.codAmount) {
            this.codAmount += Number(formValue.codAmount);
        }
        if (formValue.cod) {
            this.codAmount += Number(this.selectedService.monetaryValue) + Number(this.detailsObj.netAmount);
        }
    }

    get packages() {
        return this.form.controls["packages"] as FormArray;
    }

    addPackage() {
        const packagreForm = this.fb.group({
            account: [this.fedexAccountInfo ? this.fedexAccountInfo : "", Validators.required],
            packageType: [this.defaultPackage],
            totalPackage: [{ id: 1, name: "1" }],
            mass: [this.massOptions[0]],
            weight: [this.defaultPackage ? this.defaultPackage.data.weight : "", Validators.required],
            length: [this.defaultPackage ? this.defaultPackage.data.length : "", Validators.required],
            width: [this.defaultPackage ? this.defaultPackage.data.width : "", Validators.required],
            height: [this.defaultPackage ? this.defaultPackage.data.height : "", Validators.required],
            packageValue: [""],
            reference1: [this.channel == "SALESORDER" && this.detailsObj.salesOrderStageId == SoStageId.Shipped ? this.detailsObj?.invoiceNo : this.detailsObj?.number, Validators.required],
            reference2: [""],
            cod: [false],
            codAmount: ["17.5"],
            codMethod: [this.defaultMethod ? this.defaultMethod : ""],
            includeBatteries: [false],
            typeOfBattery: [""],
            batteryPackageType: [""],
            signature: [false],
            signatureOption: [""],
        });
        this.packages.push(packagreForm);
    }

    onPackageTypeChage(index) {
        const pType = this.packages.at(index).get("packageType").value?.data;
        if (!pType) {
            this.packages.at(index).get("length").setValue("");
            this.packages.at(index).get("width").setValue("");
            this.packages.at(index).get("height").setValue("");
            this.packages.at(index).get("weight").setValue("");
        } else if (pType.name && pType.name.startsWith("FEDEX")) {
            this.packages.at(index).get("length").setValue(pType.length);
            this.packages.at(index).get("width").setValue(pType.width);
            this.packages.at(index).get("height").setValue(pType.height);
            this.packages.at(index).get("weight").setValue(pType.weight);
            this.packages.at(index).get("length").disable();
            this.packages.at(index).get("width").disable();
            this.packages.at(index).get("height").disable();
            this.packages.at(index).get("weight").disable();
        } else {
            this.packages.at(index).get("length").setValue(pType.length);
            this.packages.at(index).get("width").setValue(pType.width);
            this.packages.at(index).get("height").setValue(pType.height);
            this.packages.at(index).get("weight").setValue(pType.weight);
            this.packages.at(index).get("length").enable();
            this.packages.at(index).get("width").enable();
            this.packages.at(index).get("height").enable();
            this.packages.at(index).get("weight").enable();
        }
    }

    getFormGroupAt(index) {
        return this.packages.at(index) as FormGroup;
    }

    removePackage(index: number) {
        this.packages.removeAt(index);
    }

    /** Ship from and to address */

    getShipperAddress(obj: any, accNo = "") {
        const shipper = {
            Name: this.prepareName(obj?.warehouse?.name),
            AttentionName: this.prepareName(obj?.warehouse?.name),
            Phone: {
                Number: obj?.warehouse?.phoneNo || "",
                Extension: " ",
            },
            ShipperNumber: accNo,
            Address: {
                AddressLine: this.prepareShipFromAddressLines(obj),
                City: obj?.warehouse?.address?.city?.name || "",
                StateProvinceCode: obj?.warehouse?.address?.state?.name || "",
                PostalCode: obj?.warehouse?.address?.zipCode || "",
                CountryCode: obj?.warehouse?.address?.country?.countryCode || "US",
            },
        };
        return shipper;
    }
    getShipToContactName() {
        let contactName = "";
        if (this.shippingAddressContact?.firstName && this.shippingAddressContact?.lastName) {
            contactName = this.shippingAddressContact.firstName + " " + this.shippingAddressContact.lastName;
        } else if (this.shippingAddressContact?.firstName) {
            contactName = this.shippingAddressContact.firstName;
        } else if (this.shippingAddressContact?.lastName) {
            contactName = this.shippingAddressContact.lastName;
        } else {
            contactName = this.detailsObj?.account?.businessName || "";
        }
        return contactName;
    }
    prepareName(data): string {
        let name = "";
        if (data) {
            name = data.length > 35 ? data.substring(0, 35) : data;
        }
        return name;
    }
    prepareShipToAddressLines(shipAddress): string[] {
        let addressLines: string[] = [];
        if (shipAddress?.address?.streetAddress2) {
            if (shipAddress?.address?.streetAddress2?.length > 35) {
                addressLines.push(shipAddress?.address?.streetAddress2.substring(0, 35));
            } else {
                addressLines.push(shipAddress?.address?.streetAddress2);
            }
        }
        if (shipAddress?.address?.streetAddress1) {
            if (shipAddress?.address?.streetAddress1?.length > 35) {
                addressLines.push(shipAddress?.address?.streetAddress1.substring(0, 35));
            } else {
                addressLines.push(shipAddress?.address?.streetAddress1);
            }
        }
        return addressLines;
    }
    getShipToAddress(shipAddress: any, obj: any) {
        const shipTo = {
            // Name: this.prepareName(obj?.account?.businessName),
            Name: this.prepareName(shipAddress?.address?.addressName && shipAddress?.address?.addressName?.length > 0 ? shipAddress?.address?.addressName : obj?.account?.businessName),
            AttentionName: this.prepareName(this.getShipToContactName()),
            Phone: {
                Number: obj?.shipContact && obj?.shipContact?.contactPhones && obj?.shipContact?.contactPhones[0]?.phone && obj?.shipContact?.contactPhones[0]?.phone?.number ? obj?.shipContact?.contactPhones[0]?.phone?.number : shipAddress?.address?.attnContact && shipAddress?.address?.attnContact?.contactPhones && shipAddress?.address?.attnContact?.contactPhones?.length ? shipAddress?.address?.attnContact?.contactPhones[0]?.phone?.number : "",
            },
            Address: {
                AddressLine: this.prepareShipToAddressLines(shipAddress),
                City: shipAddress?.address?.city?.name || "",
                StateProvinceCode: shipAddress?.address?.state?.name || "",
                PostalCode: shipAddress?.address?.zipCode || "",
                CountryCode: shipAddress?.warehouse?.address?.country?.countryCode || "US",
            },
            Residential: " ",
        };
        return shipTo;
    }
    getShipFromAddress(obj: any, accNo = "") {
        const shipFrom = {
            Name: this.prepareName(obj?.warehouse?.name),
            AttentionName: this.prepareName(obj?.warehouse?.name),
            Phone: {
                Number: obj?.warehouse?.phoneNo || "",
                Extension: " ",
            },
            ShipperNumber: accNo,
            Address: {
                AddressLine: this.prepareShipFromAddressLines(obj),
                City: obj?.warehouse?.address?.city?.name || "",
                StateProvinceCode: obj?.warehouse?.address?.state?.name || "",
                PostalCode: obj?.warehouse?.address?.zipCode || "",
                CountryCode: obj?.warehouse?.address?.country?.countryCode || "US",
            },
        };
        return shipFrom;
    }
    prepareShipFromAddressLines(obj): string[] {
        let addressLines: string[] = [];
        if (obj?.warehouse?.address?.streetAddress2) {
            if (obj?.warehouse?.address?.streetAddress2?.length > 35) {
                addressLines.push(obj?.warehouse?.address?.streetAddress2.substring(0, 35));
            } else {
                addressLines.push(obj?.warehouse?.address?.streetAddress2);
            }
        }
        if (obj?.warehouse?.address?.streetAddress1) {
            if (obj?.warehouse?.address?.streetAddress1?.length > 35) {
                addressLines.push(obj?.warehouse?.address?.streetAddress1.substring(0, 35));
            } else {
                addressLines.push(obj?.warehouse?.address?.streetAddress1);
            }
        }
        return addressLines;
    }

    /** End Ship from and to address */

    /** Customer Return shipfrom address */
    prepareCustomerReturnShipFromAddress(shipAddress: any, obj: any, accNo) {
        const shipFrom = {
            // Name: this.prepareName(obj?.account?.businessName),
            Name: this.prepareName(shipAddress?.address?.addressName && shipAddress?.address?.addressName?.length > 0 ? shipAddress?.address?.addressName : obj?.account?.businessName),
            AttentionName: this.prepareName(this.getShipToContactName()),
            Phone: {
                Number: obj?.shipContact && obj?.shipContact?.contactPhones && obj?.shipContact?.contactPhones[0]?.phone && obj?.shipContact?.contactPhones[0]?.phone?.number ? obj?.shipContact?.contactPhones[0]?.phone?.number : shipAddress?.address?.attnContact && shipAddress?.address?.attnContact?.contactPhones && shipAddress?.address?.attnContact?.contactPhones?.length ? shipAddress?.address?.attnContact?.contactPhones[0]?.phone?.number : "",
            },
            ShipperNumber: accNo,
            Address: {
                AddressLine: this.prepareShipToAddressLines(shipAddress),
                City: shipAddress?.address?.city?.name || "",
                StateProvinceCode: shipAddress?.address?.state?.name || "",
                PostalCode: shipAddress?.address?.zipCode || "",
                CountryCode: shipAddress?.warehouse?.address?.country?.countryCode || "US",
            },
        };
        return shipFrom;
    }

    /** Customer return shipto address */
    prepareCustomerReturnShipToAddress(obj: any) {
        const shipTo = {
            Name: this.prepareName(obj?.warehouse?.name),
            AttentionName: this.prepareName(obj?.warehouse?.name),
            Phone: {
                Number: obj?.warehouse?.phoneNo || "",
                Extension: " ",
            },
            Address: {
                AddressLine: this.prepareShipFromAddressLines(obj),
                City: obj?.warehouse?.address?.city?.name || "",
                StateProvinceCode: obj?.warehouse?.address?.state?.name || "",
                PostalCode: obj?.warehouse?.address?.zipCode || "",
                CountryCode: obj?.warehouse?.address?.country?.countryCode || "US",
            },
            Residential: " ",
        };
        return shipTo;
    }

    checkBillingAccount() {
        const formValue = this.form.value.packages[0];
        this.paymentDetails = {
            ShipmentCharge: {
                Type: "01",
                BillShipper: {
                    AccountNumber: formValue.account?.accountNumber,
                },
            },
        };
        this.getShippingCost();
    }

    /** Shipping Rates */
    getShippingCost() {
        if (this.form.value && this.form.value.packages && this.form.value.packages.length) {
            if (this.form.value.packages.length > 1 || Number(this.form.value.packages[0].totalPackage.name) > 1) {
                this.isSinglePackage = false;
                this.getMultiplePackageShippingRates();
            } else {
                this.isSinglePackage = true;
                this.getSinglePackageShippingRates();
            }
        }
    }
    getSinglePackageShippingRates() {
        this.ratesText = "Loading ...";
        const formValue = this.form.value.packages[0];
        const totalPck = Number(formValue.totalPackage.name);
        const ratesReqData = {
            RateRequest: {
                Request: {
                    RequestOption: "Shop",
                    TransactionReference: {
                        CustomerContext: "",
                        TransactionIdentifier: "",
                    },
                },
                Shipment: {
                    Shipper: this.channel != this.soChannel.CUSTOMER_RETURNS ? this.getShipperAddress(this.detailsObj, formValue.account?.accountNumber) : this.prepareCustomerReturnShipFromAddress(this.shippingAddress, this.detailsObj, formValue.account?.accountNumber),
                    ShipTo: this.channel != this.soChannel.CUSTOMER_RETURNS ? this.getShipToAddress(this.shippingAddress, this.detailsObj) : this.prepareCustomerReturnShipToAddress(this.detailsObj),
                    ShipFrom: this.channel != this.soChannel.CUSTOMER_RETURNS ? this.getShipFromAddress(this.detailsObj, formValue.account?.accountNumber) : this.prepareCustomerReturnShipFromAddress(this.shippingAddress, this.detailsObj, formValue.account?.accountNumber),
                    NumOfPieces: totalPck,
                    Package: {
                        PackagingType: {
                            Code: "02",
                            Description: "Packaging",
                        },
                        Dimensions: {
                            UnitOfMeasurement: {
                                Code: "IN",
                                Description: "Inches",
                            },
                            Length: formValue.length ? String(formValue.length) : "0",
                            Width: formValue.width ? String(formValue.width) : "0",
                            Height: formValue.height ? String(formValue.height) : "0",
                        },
                        PackageWeight: {
                            UnitOfMeasurement: {
                                Code: "LBS",
                                Description: "Pounds",
                            },
                            Weight: formValue.weight ? String(formValue.weight) : "0",
                        },
                        PackageServiceOptions: {
                            ...(formValue.cod && {
                                COD: {
                                    description: "",
                                    CODFundsCode: this.getCODFundsCode(formValue?.codMethod?.name ?? ""),
                                    CODAmount: {
                                        description: "",
                                        CurrencyCode: "USD", // todo
                                        MonetaryValue: formValue.codAmount ? String(formValue.codAmount) : "0",
                                    },
                                },
                            }),
                            ...(formValue.packageValue && {
                                DeclaredValue: {
                                    description: "",
                                    CurrencyCode: "USD", // todo
                                    MonetaryValue: formValue.packageValue,
                                },
                            }),
                        },
                    },
                    ShipmentRatingOptions: {
                        NegotiatedRatesIndicator: "true",
                    },
                },
            },
        };

        const rates: any[] = [];
        this.shipmentRates = [];
        this.salesOrderService.getUpsRates(this.vendorUpsInfo?.id, ratesReqData).subscribe(
            (res) => {
                if (res && res.RateResponse && res.RateResponse.RatedShipment && res.RateResponse.RatedShipment.length) {
                    res.RateResponse.RatedShipment.forEach((element) => {
                        if (element.Service && element.Service.Code) {
                            const obj = {
                                code: element.Service?.Code,
                                description: this.upsServices?.find((s) => s.serviceCode == element.Service.Code)?.serviceName ?? "", // ups doesn't return any desc
                                monetaryValue: element?.TotalCharges?.MonetaryValue,
                            };
                            rates.push(obj);
                        }
                    });
                }
                this.shipmentRates = rates;
                this.selectedService = this.shipmentRates?.find(s => s.code == this.detailsObj?.shippingMethod?.description);
                if (!res) {
                    this.ratesText = "No rates found.";
                }
            },
            (e) => {
                this.appMainService.isHideSpinner("createLabel");
                this.createLabelSubmitted = false;
                this.messageService.add({
                    severity: "error",
                    summary: this.titlecasePipe.transform("error"),
                    detail: e?.error?.Message,
                });
            },
        );
    }
    getMultiplePackageShippingRates() {
        this.ratesText = "Loading ...";
        const packages: any[] = [];
        let totalPkg = 0;

        const formValue = this.form.value.packages[0];
        this.form.value.packages.forEach((pck) => {
            for (let i = 0; i < Number(pck.totalPackage.name); i++) {
                let pkg = {
                    PackagingType: {
                        Code: "02",
                        Description: "Packaging",
                    },
                    Dimensions: {
                        UnitOfMeasurement: {
                            Code: "IN",
                            Description: "Inches",
                        },
                        Length: pck.length ? String(pck.length) : "0",
                        Width: pck.width ? String(pck.width) : "0",
                        Height: pck.height ? String(pck.height) : "0",
                    },
                    PackageWeight: {
                        UnitOfMeasurement: {
                            Code: "LBS",
                            Description: "Pounds",
                        },
                        Weight: pck.weight ? String(pck.weight) : "0",
                    },
                    PackageServiceOptions: {
                        ...(pck.cod && {
                            COD: {
                                description: "",
                                CODFundsCode: this.getCODFundsCode(formValue?.codMethod?.name ?? ""),
                                CODAmount: {
                                    description: "",
                                    CurrencyCode: "USD", // todo
                                    MonetaryValue: pck.codAmount ? String(pck.codAmount) : "0",
                                },
                            },
                        }),
                        ...(pck.packageValue && {
                            DeclaredValue: {
                                description: "",
                                CurrencyCode: "USD", // todo
                                MonetaryValue: pck.packageValue,
                            },
                        }),
                    },
                };
                packages.push(pkg);
                totalPkg++;
            }
        });

        const ratesReqData = {
            RateRequest: {
                Request: {
                    RequestOption: "Shop",
                    TransactionReference: {
                        CustomerContext: "",
                        TransactionIdentifier: "",
                    },
                },
                Shipment: {
                    Shipper: this.channel != this.soChannel.CUSTOMER_RETURNS ? this.getShipperAddress(this.detailsObj, formValue.account?.accountNumber) : this.prepareCustomerReturnShipFromAddress(this.shippingAddress, this.detailsObj, formValue.account?.accountNumber),
                    ShipTo: this.channel != this.soChannel.CUSTOMER_RETURNS ? this.getShipToAddress(this.shippingAddress, this.detailsObj) : this.prepareCustomerReturnShipToAddress(this.detailsObj),
                    ShipFrom: this.channel != this.soChannel.CUSTOMER_RETURNS ? this.getShipFromAddress(this.detailsObj, formValue.account?.accountNumber) : this.prepareCustomerReturnShipFromAddress(this.shippingAddress, this.detailsObj, formValue.account?.accountNumber),
                    NumOfPieces: totalPkg,
                    Package: packages,
                    ShipmentRatingOptions: {
                        NegotiatedRatesIndicator: "true",
                    },
                },
            },
        };

        const rates: any[] = [];
        this.shipmentRates = [];
        this.salesOrderService.getUpsRates(this.vendorUpsInfo?.id, ratesReqData).subscribe(
            (res) => {
                if (res && res.RateResponse && res.RateResponse.RatedShipment && res.RateResponse.RatedShipment.length) {
                    res.RateResponse.RatedShipment.forEach((element) => {
                        if (element.Service && element.Service.Code) {
                            const obj = {
                                code: element.Service?.Code,
                                description: this.upsServices?.find((s) => s.serviceCode == element.Service.Code)?.serviceName ?? "", // ups doesn't return any desc
                                monetaryValue: element?.TotalCharges?.MonetaryValue,
                            };
                            rates.push(obj);
                        }
                    });
                }
                this.shipmentRates = rates;
                this.selectedService = this.shipmentRates?.find(s => s.code == this.detailsObj?.shippingMethod?.description);
                if (!res) {
                    this.ratesText = "No rates found.";
                }
            },
            (e) => {
                this.appMainService.isHideSpinner("createLabel");
                this.createLabelSubmitted = false;
                this.messageService.add({
                    severity: "error",
                    summary: this.titlecasePipe.transform("error"),
                    detail: e?.error?.Message,
                });
            },
        );
    }

    /** Generate Shipping Label */
    createLabel() {
        if (this.isSinglePackage) {
            this.createLabelForSinglePackage();
        } else {
            this.createLabelForMultiplePackage();
        }
    }
    createLabelForSinglePackage() {
        this.createLabelSubmitted = true;
        const formValue = this.form.value.packages[0];
        const data = {
            ShipmentRequest: {
                Request: {
                    SubVersion: "1801",
                    RequestOption: "nonvalidate",
                    TransactionReference: {
                        CustomerContext: "",
                    },
                },
                Shipment: {
                    Description: "",
                    Shipper: this.channel != this.soChannel.CUSTOMER_RETURNS ? this.getShipperAddress(this.detailsObj, formValue.account?.accountNumber) : this.prepareCustomerReturnShipFromAddress(this.shippingAddress, this.detailsObj, formValue.account?.accountNumber),
                    ShipTo: this.channel != this.soChannel.CUSTOMER_RETURNS ? this.getShipToAddress(this.shippingAddress, this.detailsObj) : this.prepareCustomerReturnShipToAddress(this.detailsObj),
                    ShipFrom: this.channel != this.soChannel.CUSTOMER_RETURNS ? this.getShipFromAddress(this.detailsObj, formValue.account?.accountNumber) : this.prepareCustomerReturnShipFromAddress(this.shippingAddress, this.detailsObj, formValue.account?.accountNumber),
                    PaymentInformation: this.paymentDetails,
                    Service: {
                        Code: this.selectedService.code || "",
                        Description: "",
                    },
                    Package: {
                        Description: " ",
                        Packaging: {
                            Code: "02",
                            Description: "Packaging",
                        },
                        Dimensions: {
                            UnitOfMeasurement: {
                                Code: "IN",
                                Description: "Inches",
                            },
                            Length: formValue.length ? String(formValue.length) : "0",
                            Width: formValue.width ? String(formValue.width) : "0",
                            Height: formValue.height ? String(formValue.height) : "0",
                        },
                        PackageWeight: {
                            UnitOfMeasurement: {
                                Code: "LBS",
                                Description: "Pounds",
                            },
                            Weight: formValue.weight ? String(formValue.weight) : "0",
                        },
                        PackageServiceOptions: {
                            ...(formValue.cod && {
                                COD: {
                                    description: "",
                                    CODFundsCode: this.getCODFundsCode(formValue?.codMethod?.name ?? ""),
                                    CODAmount: {
                                        description: "",
                                        CurrencyCode: "USD", // todo
                                        MonetaryValue: this.codAmount ? String(this.codAmount) : "0",
                                    },
                                },
                            }),
                            ...(formValue.packageValue && {
                                DeclaredValue: {
                                    description: "",
                                    CurrencyCode: "USD", // todo
                                    MonetaryValue: formValue.packageValue,
                                },
                            }),
                            ...(formValue.signature && {
                                DeliveryConfirmation: {
                                    description: "",
                                    DCISType: formValue.signatureOption.value,
                                },
                            }),
                        },
                        ReferenceNumber: this.getReferenceNo(formValue),
                    },
                },
                LabelSpecification: {
                    LabelImageFormat: {
                        Code: "GIF",
                        Description: "GIF",
                    },
                },
            },
        };

        this.salesOrderService.createUpsLabel(this.vendorUpsInfo?.id, data).subscribe(
            (res) => {
                if (res) {
                    const data = {
                        type: "SINGLE_PACKAGE",
                        success: true,
                        label: res,
                        accountNo: formValue.account?.accountNumber,
                        selectedCarrier: this.selectedCarrier,
                        shippingCost: this.shippingCost,
                        isFreeShipping: this.isFreeShipping,
                        codCharge: formValue.cod ? formValue.codAmount : 0,
                        length: Number(formValue.length),
                        width: Number(formValue.width),
                        height: Number(formValue.height),
                        weight: Number(formValue.weight),
                        zipCode: this.shippingAddress?.address?.zipCode ?? "",
                        addressTypeId: this.shippingAddress?.address?.addressTypeId ?? "",
                        addressClassId: this.shippingAddress?.address?.addressClassId ?? "",
                        uomId: 0,
                        uomName: "Pound",
                        serviceName: this.selectedService?.description,
                        serviceMethodTypeId: 0,
                    };
                    this.messageService.add({
                        severity: "success",
                        summary: this.titlecasePipe.transform("success"),
                        detail: "Label created Successfully...",
                    });
                    this.createLabelSubmitted = false;
                    this.onSuccessfullUpsShipment.emit(data);
                } else {
                    this.appMainService.isHideSpinner("createLabel");
                    this.createLabelSubmitted = false;
                    this.messageService.add({
                        severity: "error",
                        summary: this.titlecasePipe.transform("error"),
                        detail: "",
                    });
                }
            },
            (e) => {
                this.appMainService.isHideSpinner("createLabel");
                this.createLabelSubmitted = false;
                this.messageService.add({
                    severity: "error",
                    summary: this.titlecasePipe.transform("error"),
                    detail: e?.error?.Message,
                });
            },
        );
    }
    createLabelForMultiplePackage() {
        this.createLabelSubmitted = true;
        const formValue = this.form.value.packages[0];
        let totalPck = 0;
        const packages: any[] = [];
        this.form.value.packages.forEach((pck) => {
            for (let i = 0; i < Number(pck.totalPackage.name); i++) {
                let pkg = {
                    Description: " ",
                    Packaging: {
                        Code: "02",
                        Description: "Packaging",
                    },
                    Dimensions: {
                        UnitOfMeasurement: {
                            Code: "IN",
                            Description: "Inches",
                        },
                        Length: pck.length ? String(pck.length) : "0",
                        Width: pck.width ? String(pck.width) : "0",
                        Height: pck.height ? String(pck.height) : "0",
                    },
                    PackageWeight: {
                        UnitOfMeasurement: {
                            Code: "LBS",
                            Description: "Pounds",
                        },
                        Weight: pck.weight ? String(pck.weight) : "0",
                    },
                    PackageServiceOptions: {
                        ...(pck.cod && {
                            COD: {
                                description: "",
                                CODFundsCode: this.getCODFundsCode(formValue?.codMethod?.name ?? ""),
                                CODAmount: {
                                    description: "",
                                    CurrencyCode: "USD", // todo
                                    MonetaryValue: this.codAmount ? String(this.codAmount) : "0",
                                },
                            },
                        }),
                        ...(pck.packageValue && {
                            DeclaredValue: {
                                description: "",
                                CurrencyCode: "USD", // todo
                                MonetaryValue: pck.packageValue,
                            },
                        }),
                        ...(pck.signature && {
                            DeliveryConfirmation: {
                                description: "",
                                DCISType: pck.signatureOption.value,
                            },
                        }),
                    },
                    ReferenceNumber: this.getReferenceNo(pck),
                };
                packages.push(pkg);
                totalPck++;
            }
        });

        const data = {
            ShipmentRequest: {
                Request: {
                    SubVersion: "1801",
                    RequestOption: "nonvalidate",
                    TransactionReference: {
                        CustomerContext: "",
                    },
                },
                Shipment: {
                    Description: "",
                    Shipper: this.channel != this.soChannel.CUSTOMER_RETURNS ? this.getShipperAddress(this.detailsObj, formValue.account?.accountNumber) : this.prepareCustomerReturnShipFromAddress(this.shippingAddress, this.detailsObj, formValue.account?.accountNumber),
                    ShipTo: this.channel != this.soChannel.CUSTOMER_RETURNS ? this.getShipToAddress(this.shippingAddress, this.detailsObj) : this.prepareCustomerReturnShipToAddress(this.detailsObj),
                    ShipFrom: this.channel != this.soChannel.CUSTOMER_RETURNS ? this.getShipFromAddress(this.detailsObj, formValue.account?.accountNumber) : this.prepareCustomerReturnShipFromAddress(this.shippingAddress, this.detailsObj, formValue.account?.accountNumber),
                    PaymentInformation: this.paymentDetails,
                    Service: {
                        Code: this.selectedService.code || "",
                        Description: "",
                    },
                    Package: packages,
                },
                LabelSpecification: {
                    LabelImageFormat: {
                        Code: "GIF",
                        Description: "GIF",
                    },
                },
            },
        };

        this.salesOrderService.createUpsLabel(this.vendorUpsInfo?.id, data).subscribe(
            (res) => {
                if (res) {
                    const data = {
                        type: "MULTI_PACKAGE",
                        success: true,
                        label: res,
                        accountNo: formValue.account?.accountNumber,
                        selectedCarrier: this.selectedCarrier,
                        shippingCost: this.shippingCost,
                        isFreeShipping: this.isFreeShipping,
                        codCharge: formValue.cod ? formValue.codAmount : 0,
                        serviceName: this.selectedService?.description,
                        serviceMethodTypeId: 0,
                    };
                    this.messageService.add({
                        severity: "success",
                        summary: this.titlecasePipe.transform("success"),
                        detail: "Label created Successfully...",
                    });
                    this.createLabelSubmitted = false;
                    this.onSuccessfullUpsShipment.emit(data);
                } else {
                    this.appMainService.isHideSpinner("createLabel");
                    this.createLabelSubmitted = false;
                    this.messageService.add({
                        severity: "error",
                        summary: this.titlecasePipe.transform("error"),
                        detail: "",
                    });
                }
            },
            (e) => {
                this.appMainService.isHideSpinner("createLabel");
                this.createLabelSubmitted = false;
                this.messageService.add({
                    severity: "error",
                    summary: this.titlecasePipe.transform("error"),
                    detail: e?.error?.Message,
                });
            },
        );
    }

    onDialogClose() {
        this.onClose.emit();
    }

    isNumberKey(evt) {
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
        return true;
    }

    showShippingCostField() {
        this.isVisibleShipCostField = true;
    }

    hideShippingCostField() {
        this.isVisibleShipCostField = false;
        this.codAmount = 0;
        const formValue = this.form.value.packages[0];
        if (formValue.cod && formValue.codAmount) {
            this.codAmount += Number(formValue.codAmount);
        }
        if (formValue.cod) {
            this.codAmount += Number(this.shippingCost) + Number(this.detailsObj.netAmount);
        }
    }

    showCodField() {
        this.isVisibleCodField = true;
    }

    hideCodField() {
        this.isVisibleCodField = false;
    }

    changeCODAmount() {
        if (this.isFreeShipping) {
            const formValue = this.form.value.packages[0];
            if (formValue.cod && formValue.codAmount) {
                this.codAmount -= Number(formValue.codAmount) + Number(this.shippingCost);
            }
        } else {
            this.codAmount = 0;
            const formValue = this.form.value.packages[0];
            if (formValue.cod && formValue.codAmount) {
                this.codAmount += Number(formValue.codAmount);
            }
            if (formValue.cod) {
                this.codAmount += Number(this.shippingCost) + Number(this.detailsObj.netAmount);
            }
        }
    }

    getAllCountry() {
        this.shippingService.getCountry().subscribe((country) => {
            this.country = country;
        });
    }

    async getAsyncStatesFromCountry(country) {
        let countryID = country.id;
        await this.shippingService.getAllStates(countryID).then((states) => {
            this.states = states;
            this.selectedState = null;
        });
    }

    async getAsyncCitiesFromState(state) {
        await this.shippingService.getAllCities(state.id).then((cities) => {
            this.city = cities;
            this.selectedCity = null;
        });
    }

    getSpecialServiceTypes(formValue) {
        const specialServiceTypes: any[] = [];
        if (formValue.cod) {
            specialServiceTypes.push("COD");
        }
        if (formValue.includeBatteries) {
            specialServiceTypes.push("DANGEROUS_GOODS");
        }
        return specialServiceTypes;
    }

    getSignatureOptionType(formValue) {
        const signatureOptionType: any[] = [];
        if (formValue.signature) {
            signatureOptionType.push("DIRECT");
        } else {
            signatureOptionType.push("NO_SIGNATURE_REQUIRED");
        }
        return signatureOptionType;
    }
    getReferenceNo(formValue) {
        const referenceNumber: any[] = [];
        if (formValue.reference1) {
            const obj = {
                description: "",
                Value: formValue.reference1,
            };
            referenceNumber.push(obj);
        }
        if (formValue.reference2) {
            const obj = {
                description: "",
                Value: formValue.reference2,
            };
            referenceNumber.push(obj);
        }
        return referenceNumber;
    }

    getCODFundsCode(name: string): string {
        if (this.codFundsCodeEightFor.includes(name.toLowerCase())) {
            return "8";
        }
        return "0";
    }
}
